import "./contact.css";
import { BsTwitterX, BsLinkedin, BsEnvelope, BsGithub } from "react-icons/bs";
import { useForm, ValidationError } from "@formspree/react";

const Contact = () => {
  const [state, handleSubmit] = useForm("xnnddzeo");

  return (
    <section className="contact-container" aria-labelledby="contact-heading">
      <h2 id="contact-heading" className="visually-hidden">
        Contact Information
      </h2>

      <div className="contact-social">
        <h3 className="contact-subheading">Connect with Me</h3>
        <ul className="contact-list">
          <li>
            <a
              href="https://x.com/rebusnardo"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow me on X"
            >
              <BsTwitterX className="contact-icon" />
              X
            </a>
          </li>
          <li>
            <a
              href="mailto:ronbusnardodeveloper@gmail.com"
              aria-label="Send me an email"
            >
              <BsEnvelope className="contact-icon" />
              Email
            </a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/in/ron-busnardo/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Connect with me on LinkedIn"
            >
              <BsLinkedin className="contact-icon" />
              LinkedIn
            </a>
          </li>
          <li>
            <a
              href="https://github.com/rebusnardo"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit my GitHub"
            >
              <BsGithub className="contact-icon" />
              GitHub
            </a>
          </li>
        </ul>
      </div>

      <div className="contact-form-container">
        <h3 className="contact-subheading">Send a Message</h3>
        {state.succeeded ? (
          <p className="form-message success">Message sent successfully!</p>
        ) : (
          <form
            className="contact-form"
            onSubmit={handleSubmit}
            aria-labelledby="contact-form-heading"
          >
            <h4 id="contact-form-heading" className="visually-hidden">
              Contact Form
            </h4>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                id="name"
                name="name"
                type="text"
                required
                aria-required="true"
              />
              <ValidationError
                prefix="Name"
                field="name"
                errors={state.errors}
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                name="email"
                type="email"
                required
                aria-required="true"
              />
              <ValidationError
                prefix="Email"
                field="email"
                errors={state.errors}
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                required
                aria-required="true"
              ></textarea>
              <ValidationError
                prefix="Message"
                field="message"
                errors={state.errors}
              />
            </div>
            <button type="submit" disabled={state.submitting}>
              Send
            </button>
          </form>
        )}
      </div>
    </section>
  );
};

export default Contact;